<template>
  <div class="scoreboard">
    <header>
      <div>
        <h1>CAS Digital Typography</h1>
        <h1 class="light">Dingsbumsui</h1>
        <p class="intro">
          Interactive design challenges, played in realtime by 8 teams of two. Each team owns a Figma file containing
          the challenges to be worked on. The design is shown and validated in real time here on the scoreboard. Each
          round, the teams will play against the clock to achieve the best result.
        </p>
        <p class="intro">CAS Digital Typography at the Zürcher Hochschule der Künste.</p>
      </div>
      <div>
        <h4 class="light">Round</h4>
        <h1 class="light">{{ currentChallenge }} / 6</h1>
        <div style="margin-top: 1rem">
          <button @click="running = !running" :class="{ red: running }">{{ running ? "Stop" : "Start" }}</button>
          <button class="outline" @click="nextChallenge">Next</button>
        </div>
      </div>
      <div>
        <h4 class="light">All</h4>
        <h1 class="light">Teams</h1>
        <ol>
          <li v-for="team in sortedTeams">
            <div>{{ team.name }}</div>
          </li>
        </ol>
      </div>
    </header>
    <div class="teams" :style="computedTeamsStyle">
      <div class="team" v-for="(team, index) in filteredTeams">
        <div class="team-title">
          <div style="display: flex;">
            <!-- <div class="team-score" style="margin-right: 1rem">{{ team.score }}</div> -->
            <div>
              <div class="team-name-wrapper">
                <div v-if="selected != -1" @click="$store.dispatch('selectTeam', -1)" class="team-back">↵</div>
                <div class="color-chip" :style="{ background: team.color }"></div>

                <h1 class="team-name" @click="$store.dispatch('selectTeam', index)">Team {{ team.name }}</h1>
              </div>
              <h2 class="team-members">{{ team.members.join(" & ") || "—" }}</h2>
            </div>
          </div>
        </div>
        <div class="team-canvas">
          <iframe
            style="border: none;"
            width="100%"
            height="300"
            :src="team.url + nodeIdPrefix + challenges[currentChallenge]"
            allowfullscreen
            :style="{ opacity: running ? 0 : 1 }"
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    challenges: {
      type: Array,
      default() {
        return [];
      }
    },
    teams: Array,
    nodeId: {
      type: String,
      default: "982%253A52"
    }
  },
  computed: {
    ...mapState({
      currentChallenge: (state) => state.currentChallenge,
      running: (state) => state.running,
      selected: (state) => state.selected,
      nodeIdPrefix: (state) => state.nodeIdPrefix
    }),
    sortedTeams() {
      return this.teams;
    },
    computedTeamsStyle() {
      return {
        "grid-template-columns": this.selected != -1 ? "1fr" : "repeat(4, 1fr)"
      };
    },
    filteredTeams() {
      return this.selected != -1 ? [this.teams[this.selected]] : this.teams;
    }
  },
  methods: {
    add(name, url) {
      this.teams.push({
        name: name,
        url: url,
        score: "1",
        color: "black"
      });
    },
    nextChallenge() {
      this.$store.dispatch("nextChallenge");
    }
  },
  mounted: function() {}
};
</script>

<style scoped>
.scoreboard {
}
.light {
  font-weight: 400;
}

.team {
  margin-bottom: 5%;
}

.team-back {
  font-size: 2rem;
  margin-right: 1rem;
  cursor: pointer;
}
.team-back:hover {
  opacity: 0.5;
}
.team-name-wrapper {
  display: flex;
  align-items: center;
}

.teams {
  display: grid;
  grid-gap: 2rem;
  padding: 5%;
  display: grid;
  grid-template-rows: 1fr 100px 1fr;
}

.team-title {
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  margin-bottom: 1rem;
}

.team-name {
  font-size: 1.5rem;
  text-align: left;
}

.team-members {
  font-style: 1rem;
  font-weight: 400;
  opacity: 0.5;
}

.team-score {
  font-size: 4rem;
  font-weight: 300;
  font-family: "Fira Code", monospace;
  width: 50px;
  align-self: flex-start;
  vertical-align: top;
  margin-top: -8px;
}

hr {
  margin: 4rem 0;
}
.team-canvas {
  background: #333;
  height: 300px;
}
.team-canvas iframe {
  transition: opacity 1s;
  display: inline-block;
}
iframe {
  border: 0;
  background: transparent;
}
header {
  /* background: #100050; */
  background: black;
  background-image: linear-gradient(to bottom, #222, #000);
  color: white;
  padding: 5%;
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  grid-gap: 2rem;
}
h4 {
  opacity: 0.6;
}

button {
  padding: 0.5rem 2rem;
  background: white;
  font-size: 12px;
  border: none;
  border-radius: 0px;
  margin-right: 1rem;
  background: #1cb955;
  color: white;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.15s;
}
button:hover {
  transform: scale(1.05);
  background: #21db65;
}

.red {
  background: red;
}
.red:hover {
  background: red;
}
button.outline {
  background: transparent;
  border: 1px solid white;
}

button:focus {
  outline: none;
}

.yellow {
  color: #ffcc00;
}

ol {
  margin-left: 1rem;
  margin-top: 1rem;
}

ol li {
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  padding: 0.25rem 0;
  color: rgba(255, 255, 255, 0.5);
}
.emoji {
  color: rgba(255, 255, 255, 1);
  margin-left: 1rem;
}

.list-item {
  display: flex;
  justify-content: space-between;
}

.intro {
  margin-top: 1rem;
  opacity: 0.5;
}
.color-chip {
  width: 24px;
  height: 24px;
  border-radius: 100px;
  margin-right: 1rem;
  border: 1px solid rgba(0, 0, 0, 0.5);
}

.inline {
  display: flex;
  justify-content: center;
}
</style>
